import React from 'react';
import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function GenericModal({ open, handleClose, title, children }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="generic-modal-title"
      aria-describedby="generic-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 500, lg: "800px" },
          maxHeight: '100vh', // Set a maximum height for the modal
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          outline: 'none',
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography id="generic-modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            maxHeight: '75vh', // Set a fixed height for the content area
            overflow: 'auto', // Enable scrolling if content exceeds max height
          }}
          mb={2}
        >
          {children}
        </Box>
      </Box>
    </Modal>
  );
}

export default GenericModal;
